export var getComponentOverride = function getComponentOverride(componentName) {
  return function (_ref) {
    var theme = _ref.theme;

    if (theme) {
      var currentTheme = theme.armor || theme;
      var __componentOverrides = currentTheme.__componentOverrides,
          componentOverrides = currentTheme.componentOverrides,
          components = currentTheme.components;

      if (__componentOverrides && componentName in __componentOverrides) {
        return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.__componentOverrides[componentName];
      }

      if (componentOverrides && componentName in componentOverrides) {
        return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.componentOverrides[componentName];
      }

      if (components && componentName in components) {
        return currentTheme === null || currentTheme === void 0 ? void 0 : currentTheme.components[componentName];
      }
    }

    return null;
  };
};